<template>
  <div class="card" v-show="currentCardId == 'pr-message'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>自己PRを入力</h2>
        <p>英文レジュメでは Profile としてトップに表示されます</p>
      </div>
      <div class="card-content">
        <EnglishProfileAiCard
          :current-value="formatData.prMessage"
          @adopt-profile="handleAdoptProfile"
        />
        <el-input
          type="textarea"
          v-model="formatData.prMessage"
          :autosize="{ minRows: 6, maxRows: 15 }"
          :maxlength="MAX_PR_MESSAGE_LENGTH"
          show-word-limit
          placeholder="Experienced software engineer with ..."
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import EnglishProfileAiCard from '@/components/yagiprime/EnglishProfileAiCard.vue'
import {
  MAX_PR_MESSAGE_LENGTH,
  useEnglishResumeFormatData
} from '@/composables/format-edit/useEnglishResumeFormatData'

defineProps<{
  currentCardId?: string
}>()

const formatData = useEnglishResumeFormatData()

function handleAdoptProfile(text: string) {
  formatData.prMessage = text
}
</script>
